import { ReactNode } from 'react';

export interface ViewportActionCornersComponentInfo {
	id: string;
	component: ReactNode;
}
